<button mat-button color="primary-outline" [routerLink]="['/reports/' + report_id + '/view']">Bekijk rapportage</button>
<ng-container *ngIf="dataLoaded && !missingData.length">
	<dl *ngIf="report">
		<dt>Rapportage nummer</dt>
		<dd>{{ report.report_nr }}</dd>
		<dt>Inspecteur</dt>
		<dd>{{ report.inspector }}</dd>
		<dt>Datum aangemaakt</dt>
		<dd *ngIf="report.created !== null">{{ report.created | datex:'DD-MM-YYYY' }}</dd>
		<dd *ngIf="report.created === null">-</dd>
		<dt>Datum aangepast</dt>
		<dd *ngIf="report.modified !== null">{{ report.modified | datex:'DD-MM-YYYY' }}</dd>
		<dd *ngIf="report.modified === null">-</dd>
	</dl>
	<form class="with-action-buttons" [formGroup]="reportSendToClientForm" (ngSubmit)="reportsService.sendToEmail(report_id, reportSendToClientForm.value)">
		<div class="divider"><span>Verstuur naar aangepaste ontvanger</span></div>
		<mat-form-field>
			<textarea title="" matInput placeholder="Aangepaste ontvanger" formControlName="custom_contacts" rows="8"></textarea>
			<mat-error *ngIf="formsService.getFieldError('custom_contacts')">{{formsService.getFieldError('custom_contacts')}}</mat-error>
		</mat-form-field>
		<div class="divider"><span>Bijlagen</span></div>
		<div>
			<mat-radio-group color="primary" formControlName="report_format">
				<mat-radio-button value="pdf">PDF rapportage</mat-radio-button>
				<mat-radio-button value="xlsx">Excel rapportage</mat-radio-button>
				<mat-radio-button value="both">PDF & Excel rapportage</mat-radio-button>
			</mat-radio-group>
		</div>
		<div class="divider"><span>Bericht gegevens</span></div>
		<mat-form-field>
			<textarea title="" matInput placeholder="Notities" formControlName="message" rows="8"></textarea>
			<mat-error *ngIf="formsService.getFieldError('message')">{{formsService.getFieldError('message')}}</mat-error>
		</mat-form-field>
		<div class="action-buttons">
			<button color="primary" mat-button [disabled]="!reportSendToClientForm.valid">VERSTUUR</button>
		</div>
	</form>
</ng-container>
<div *ngIf="missingData.length" class="alert alert-danger" fxFlex fxLayout="row">
	<mat-icon>warning</mat-icon>
	<h2>Niet alle data is beschikbaar online, ga online om verder te gaan.</h2>
</div>
